import type { MailboxInfo } from "owa-client-types";
import getGlobalSettingsAccountMailboxInfo from "./getGlobalSettingsAccountMailboxInfo";
import isAccountSourceListStoreInitialized from "../utils/isAccountSourceListStoreInitialized";
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from "owa-analytics-types";
import { logStartGreyError } from "owa-analytics-start";

/**
 * Returns the MailboxInfo for the global settings account account, if the account source list store
 * is not initialized, this will return an undefined object. This function provides a non throwing
 * way to get the global settings account mailbox info, which is useful in cases where the account
 * source list store is not initialized.
 * @returns MailboxInfo for the global settings account or undefined if the account source list store is not initialized
 */
export default function tryGetGlobalSettingsAccountMailboxInfo(logGreyError: boolean = true): MailboxInfo | undefined {
    if (!isAccountSourceListStoreInitialized()) {
        // the account source list store is not initialzied, we wont be able to
        // determine if the global settings account so we return undefined.
        if (logGreyError) {
            logStartGreyError("NoGSA_AccountSourceListStoreNotInitialized", 
            /* eslint-disable-next-line owa-custom-rules/telemetry-no-global-account-routing -- (https://aka.ms/OWALintWiki)
             * Account-agnostic telemetry: this error fires precisely because the account source
             * list store is not initialized, so no MailboxInfo (including the global settings
             * account) is obtainable at this point. The event tracks pre-account-context
             * infrastructure state and cannot be associated with a specific mailbox. */
            INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT);
        }
        
        return undefined;
    }
    
    return getGlobalSettingsAccountMailboxInfo();
}
